import React from 'react';
import styles from './OrientationPrompt.module.css';
import rotatePhoneVideo from '../../assets/rotate-phone.webm';

interface OrientationPromptProps {
  showPrompt?: boolean;
  onPromptDismiss?: (() => void) | null;
}

const OrientationPrompt: React.FC<OrientationPromptProps> = ({ 
  showPrompt = false,
  onPromptDismiss = null
}) => {
  const handleDismiss = () => {
    if (onPromptDismiss) {
      onPromptDismiss();
    }
  };

  if (!showPrompt) {
    return null;
  }

  return (
    <div className={styles['orientation-prompt-overlay']} onClick={handleDismiss}>
      <div className={styles['orientation-prompt-modal']} onClick={e => e.stopPropagation()}>
        <button className={styles['orientation-prompt-close']} onClick={handleDismiss} aria-label="Close">×</button>
        <div className={styles['orientation-prompt-icon-modern']}>
          <video
            className={styles['iphone-rotate-video']}
            src={rotatePhoneVideo}
            autoPlay
            loop
            muted
            playsInline
          />
        </div>
      </div>
    </div>
  );
};

export default OrientationPrompt;
